import React from 'react'
import { Link } from 'react-router-dom'

import slack from "../../../assets/images/slack.svg"
import slacklogo from "../../../assets/images/slack-logo.svg"
import banner from "../../../assets/images/mail-banner.png"
import logoicon from "../../../assets/images/logo-icon.svg"

const InviteYourTeam = ({selectedMail, toggleMail} : any) => {

  return (
    <React.Fragment>
      <div
            className={`flex-1 overflow-y-auto md:h-[calc(100vh-212px)] border border-black/10 rounded absolute top-0 left-0 bg-white dark:bg-darklight dark:border-darkborder md:static h-full ${!selectedMail ? "hidden md:block" : ""}`}
          >
            <div className="flex items-center gap-3 px-4 py-2 border-b bg-light/20 border-black/10 dark:border-darkborder dark:bg-white/5">
              <button
                type="button"
                className="md:hidden"
                onClick={() => toggleMail(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 256 256"
                >
                  <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                </svg>
              </button>
              <p className="font-semibold dark:text-white/80">
                Invite your team to Slack
              </p>
            </div>
            <div className="flex flex-wrap items-start justify-between gap-3 px-4 py-2 border-b bg-light/20 border-black/10 dark:border-darkborder dark:bg-white/5">
              <div className="flex items-start flex-1 gap-2 p-1">
                <img
                  className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                  src={slack}
                  alt=""
                />
                <div className="flex-1 ltr:text-left rtl:text-right">
                  <p className="dark:text-white">
                    Slack <span className="text-muted">|</span>{" "}
                    no-reply@email.slackhq.com
                  </p>
                  <p className="text-xs text-muted dark:text-darkmuted">
                    Today, 18:30
                  </p>
                </div>
              </div>
              <div className="flex items-center flex-none gap-1">
                <button className="p-1 text-black rounded hover:bg-black/5 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.69171 4.81718C6.80892 4.69997 6.875 4.54076 6.875 4.375C6.875 4.20924 6.80915 4.05027 6.69194 3.93306L6.68655 3.92773C6.56983 3.814 6.41296 3.75 6.25 3.75C6.23125 3.75 6.21251 3.75084 6.19384 3.75253C6.04808 3.76568 5.91155 3.82957 5.80806 3.93306L2.05806 7.68306C1.94085 7.80027 1.875 7.95924 1.875 8.125C1.875 8.29076 1.94085 8.44973 2.05806 8.56694L5.80806 12.3169C5.92527 12.4342 6.08424 12.5 6.25 12.5C6.41576 12.5 6.57473 12.4342 6.69194 12.3169C6.80915 12.1997 6.875 12.0408 6.875 11.875C6.875 11.7092 6.80915 11.5503 6.69194 11.4331L3.38388 8.125L6.69171 4.81718Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M10 7.5H2.5C2.15482 7.5 1.875 7.77982 1.875 8.125C1.875 8.47018 2.15482 8.75 2.5 8.75H10C11.3675 8.75 12.6309 9.27333 12.6309 9.27333C13.8944 9.79665 14.8614 10.7636 14.8614 10.7636C15.8283 11.7306 16.3517 12.9941 16.3517 12.9941C16.875 14.2575 16.875 15.625 16.875 15.625C16.875 15.9702 17.1548 16.25 17.5 16.25C17.8452 16.25 18.125 15.9702 18.125 15.625C18.125 14.0088 17.5065 12.5157 17.5065 12.5157C16.888 11.0226 15.7452 9.87976 15.7452 9.87976C14.6024 8.73696 13.1093 8.11848 13.1093 8.11848C11.6162 7.5 10 7.5 10 7.5Z"
                      fill="currentcolor"
                    />
                  </svg>
                </button>
                <button className="p-1 text-black rounded hover:bg-black/5 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.69171 4.81718C6.80892 4.69997 6.875 4.54076 6.875 4.375C6.875 4.20924 6.80915 4.05027 6.69194 3.93306L6.68655 3.92773C6.56983 3.814 6.41296 3.75 6.25 3.75C6.23125 3.75 6.21251 3.75084 6.19384 3.75253C6.04808 3.76568 5.91155 3.82957 5.80806 3.93306L2.05806 7.68306C1.94085 7.80027 1.875 7.95924 1.875 8.125C1.875 8.29076 1.94085 8.44973 2.05806 8.56694L5.80806 12.3169C5.92527 12.4342 6.08424 12.5 6.25 12.5C6.41576 12.5 6.57473 12.4342 6.69194 12.3169C6.80915 12.1997 6.875 12.0408 6.875 11.875C6.875 11.7092 6.80915 11.5503 6.69194 11.4331L3.38388 8.125L6.69171 4.81718Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M10.4417 4.81718C10.5589 4.69997 10.625 4.54076 10.625 4.375C10.625 4.20924 10.5592 4.05027 10.4419 3.93306L10.4365 3.92773C10.3198 3.814 10.163 3.75 10 3.75C9.98125 3.75 9.96251 3.75084 9.94384 3.75253C9.79808 3.76568 9.66155 3.82957 9.55806 3.93306L5.80806 7.68306C5.69085 7.80027 5.625 7.95924 5.625 8.125C5.625 8.29076 5.69085 8.44973 5.80806 8.56694L9.55806 12.3169C9.67527 12.4342 9.83424 12.5 10 12.5C10.1658 12.5 10.3247 12.4342 10.4419 12.3169C10.5592 12.1997 10.625 12.0408 10.625 11.875C10.625 11.7092 10.5592 11.5503 10.4419 11.4331L7.13388 8.125L10.4417 4.81718Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M10 7.5H6.25C5.90482 7.5 5.625 7.77982 5.625 8.125C5.625 8.47018 5.90482 8.75 6.25 8.75H10C11.3675 8.75 12.6309 9.27333 12.6309 9.27333C13.8944 9.79666 14.8614 10.7636 14.8614 10.7636C15.8283 11.7306 16.3517 12.9941 16.3517 12.9941C16.875 14.2575 16.875 15.625 16.875 15.625C16.875 15.9702 17.1548 16.25 17.5 16.25C17.8452 16.25 18.125 15.9702 18.125 15.625C18.125 14.0088 17.5065 12.5157 17.5065 12.5157C16.888 11.0226 15.7452 9.87976 15.7452 9.87976C14.6024 8.73696 13.1093 8.11848 13.1093 8.11848C11.6162 7.5 10 7.5 10 7.5Z"
                      fill="currentcolor"
                    />
                  </svg>
                </button>
                <button className="p-1 text-black rounded hover:bg-black/5 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.1919 3.93306C14.0747 3.81585 13.9158 3.75 13.75 3.75C13.5842 3.75 13.4253 3.81585 13.3081 3.93306C13.1908 4.05027 13.125 4.20924 13.125 4.375C13.125 4.54076 13.1908 4.69973 13.3081 4.81694L16.6161 8.125L13.3083 11.4328C13.1911 11.55 13.125 11.7092 13.125 11.875C13.125 11.885 13.1252 11.895 13.1257 11.905C13.1332 12.0602 13.1982 12.2071 13.3081 12.3169C13.4253 12.4342 13.5842 12.5 13.75 12.5C13.9158 12.5 14.0747 12.4342 14.1919 12.3169L17.9419 8.56694C18.0592 8.44973 18.125 8.29076 18.125 8.125C18.125 7.95924 18.0592 7.80027 17.9419 7.68306L14.1919 3.93306Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M10 8.75H17.5C17.8452 8.75 18.125 8.47018 18.125 8.125C18.125 7.77982 17.8452 7.5 17.5 7.5H10C8.38384 7.5 6.8907 8.11848 6.8907 8.11848C5.39756 8.73696 4.25476 9.87976 4.25476 9.87976C3.11196 11.0226 2.49348 12.5157 2.49348 12.5157C1.87509 14.0086 1.875 15.6246 1.875 15.6246C1.875 15.7903 1.94085 15.9497 2.05806 16.0669C2.17527 16.1842 2.33424 16.25 2.5 16.25C2.84518 16.25 3.125 15.9702 3.125 15.625C3.125 14.2575 3.64833 12.9941 3.64833 12.9941C4.17166 11.7306 5.13864 10.7636 5.13864 10.7636C6.10563 9.79666 7.36905 9.27333 7.36905 9.27333C8.63248 8.75 10 8.75 10 8.75Z"
                      fill="currentcolor"
                    />
                  </svg>
                </button>
                <button className="p-1 text-black rounded hover:bg-black/5 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 8.75C5.69036 8.75 6.25 9.30964 6.25 10C6.25 10.6904 5.69036 11.25 5 11.25C4.30964 11.25 3.75 10.6904 3.75 10C3.75 9.30964 4.30964 8.75 5 8.75Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M10 8.75C10.6904 8.75 11.25 9.30964 11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M16.25 10C16.25 9.30964 15.6904 8.75 15 8.75C14.3096 8.75 13.75 9.30964 13.75 10C13.75 10.6904 14.3096 11.25 15 11.25C15.6904 11.25 16.25 10.6904 16.25 10Z"
                      fill="currentcolor"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="rounded pt-10 md:h-[calc(100vh-312px)] overflow-y-auto">
              <div className="px-10 pb-10">
                <img
                  src={slacklogo}
                  alt="slack logo"
                  className="mb-7"
                />
                <h3 className="text-2xl font-semibold text-black dark:text-white mb-7">
                  Invite your team
                </h3>
                <p className="mb-7 dark:text-darkmuted">
                  Slack is most useful when your whole team can join the
                  conversation. Try adding people to Sliced Admin Community to
                  start being more productive together!
                </p>
                <Link
                  to="#"
                  className="btn bg-black dark:bg-white dark:text-black dark:border-white dark:hover:bg-white/85 dark:hover:border-white/85 border border-black rounded-md text-white transition-all duration-300 hover:bg-black/[0.85] hover:border-black/[0.85] inline-block mb-7"
                >
                  Invite People
                </Link>
                <img
                  src={banner}
                  alt="banner"
                  className="w-full mb-7"
                />
                <div className="flex flex-col items-center justify-between gap-6 lg:flex-row mb-7">
                  <div className="flex items-start flex-1 gap-2 p-1">
                    <img
                      className="flex-none object-cover w-10 h-10 overflow-hidden rounded-full"
                      src={logoicon}
                      alt=""
                    />
                    <div className="flex-1 text-left dark:text-darkmuted">
                      <p className="font-semibold">Sliced Admin Community</p>
                      <p>Workspace URL: Sliced-community</p>
                      <p>Email: Stevens@live.com</p>
                    </div>
                  </div>
                  <Link
                    to="#"
                    className="inline-block text-black transition-all duration-300 border rounded-md btn border-light dark:text-white dark:hover:text-black hover:bg-light hover:text-black"
                  >
                    Sign In
                  </Link>
                </div>
                <p className="text-center text-muted dark:text-white">
                  &copy;2023 Slack Technologies, LLC, a Salesforce company.
                </p>
              </div>
              <div className="flex justify-end gap-4 px-4 py-2 border-t bg-light/20 border-black/10 dark:border-darkborder dark:bg-white/5">
                <Link
                  to="#"
                  className="btn bg-light border border-light rounded-md text-black transition-all duration-300 hover:bg-light/[0.85] hover:border-light/[0.85] flex items-center gap-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="w-5 h-5"
                  >
                    <path
                      fill="currentColor"
                      d="M5.82843 6.99955L8.36396 9.53509L6.94975 10.9493L2 5.99955L6.94975 1.0498L8.36396 2.46402L5.82843 4.99955H13C17.4183 4.99955 21 8.58127 21 12.9996C21 17.4178 17.4183 20.9996 13 20.9996H4V18.9996H13C16.3137 18.9996 19 16.3133 19 12.9996C19 9.68584 16.3137 6.99955 13 6.99955H5.82843Z"
                    ></path>
                  </svg>
                  <span>Reply</span>
                </Link>
                <Link
                  to="#"
                  className="btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85] flex items-center gap-2"
                >
                  <span>Forward</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="w-5 h-5"
                  >
                    <path
                      fill="currentColor"
                      d="M18.1716 6.99955H11C7.68629 6.99955 5 9.68584 5 12.9996C5 16.3133 7.68629 18.9996 11 18.9996H20V20.9996H11C6.58172 20.9996 3 17.4178 3 12.9996C3 8.58127 6.58172 4.99955 11 4.99955H18.1716L15.636 2.46402L17.0503 1.0498L22 5.99955L17.0503 10.9493L15.636 9.53509L18.1716 6.99955Z"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
    </React.Fragment>
  )
}

export default InviteYourTeam
